module.exports = __webpack_public_path__ + "media/channel_pages/shakespeare-in-the-garden-304c3225.png";